import { render, staticRenderFns } from "./HeadlineData.vue?vue&type=template&id=62011756&scoped=true&"
import script from "./HeadlineData.vue?vue&type=script&lang=js&"
export * from "./HeadlineData.vue?vue&type=script&lang=js&"
import style0 from "./HeadlineData.vue?vue&type=style&index=0&id=62011756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62011756",
  null
  
)

export default component.exports